import React, { FC, useContext, useMemo } from 'react';

// context
import { EditorContext } from '../../../../context/EditorContext';

// models
import { SMSPreviewModel } from '../../../../models/editor.model';
import { PreviewComponentProps } from '../../../../models/formula.model';

// components
import Phone from '../shared/Phone';
import SmsPreview from './SmsPreview';

const SmsMain: FC<
    React.PropsWithChildren<PreviewComponentProps<SMSPreviewModel>>
> = ({ randomSample, formulaHasVariant }) => {
    const { editorDetails } = useContext(EditorContext);

    const hasText = useMemo(() => {
        const previews = editorDetails.previews?.[0] as any;
        return previews?.content.message;
    }, [editorDetails.previews]);

    return (
        <Phone hasText={hasText} formulaHasVariant={formulaHasVariant}>
            {randomSample.map((preview, i) => (
                <SmsPreview
                    key={i + preview.id}
                    id={preview.id}
                    formula_id={preview.formula_id}
                    content={preview.content}
                    phonePreview={true}
                />
            ))}
        </Phone>
    );
};

export default SmsMain;
